export const BLOCKED_FAILED_PAYMENT_MODAL = 'go4ellis/Modals/BLOCKED_FAILED_PAYMENT_MODAL';
export const SHOW_SCHEDULING_CONFLICT = 'go4ellis/Modals/SHOW_SCHEDULING_CONFLICT';
export const DISMISS_SCHEDULING_CONFLICT = 'go4ellis/Modals/DISMISS_SCHEDULING_CONFLICT';
export const WAIT_UNTIL_FAILED_PAYMENT_PROCESS = 'go4ellis/Modals/WAIT_UNTIL_FAILED_PAYMENT_PROCESS';

const blockedForFailedPaymentReducer = state => ({
  ...state,
  blockedForFailedPayment: !state.blockedForFailedPayment
})

const waitUntilFailedPaymentProcessReducer = state => ({
  ...state,
  waitUntilFailedPaymentProcess: !state.waitUntilFailedPaymentProcess
})

// A save the API refused because an AT would end up in two places at once
// (GO4-1808). Raised from the shift edit and from the per-job edit alike, so it
// lives here rather than in either feature's own duck.
export const showSchedulingConflict = payload => ({
  type: SHOW_SCHEDULING_CONFLICT,
  payload,
});

export const dismissSchedulingConflict = () => ({
  type: DISMISS_SCHEDULING_CONFLICT,
});

export const triggerBlockedFailedPaymentModal = () => ({
  type: BLOCKED_FAILED_PAYMENT_MODAL,
})

export const triggerWaitUntilFailedPaymentProcessModal = () => ({
  type: WAIT_UNTIL_FAILED_PAYMENT_PROCESS,
})

const DEFAULT_STATE = {
  blockedForFailedPayment: false,
  waitUntilFailedPaymentProcess: false,
  schedulingConflict: null,
};

export default function reducer(state = DEFAULT_STATE, action = {}) {
  switch (action.type) {
    case BLOCKED_FAILED_PAYMENT_MODAL:
      return blockedForFailedPaymentReducer(state);
    case WAIT_UNTIL_FAILED_PAYMENT_PROCESS:
      return waitUntilFailedPaymentProcessReducer(state);
    case SHOW_SCHEDULING_CONFLICT:
      return { ...state, schedulingConflict: action.payload };
    case DISMISS_SCHEDULING_CONFLICT:
      return { ...state, schedulingConflict: null };
    default: return state;
  }
}